import { Interface } from '@ethersproject/abi'
import STAKE_POOL_ABI from './StakePool.json'

const STAKE_POOL_INTERFACE = new Interface(STAKE_POOL_ABI)

export { STAKE_POOL_INTERFACE }
